const barcodeTranslation = {
  menu: '바코드',
  barcodeMenu: '바코드',
  specialBarcodeMenu: '예외 바코드 관리',
  specialBarcodeTab: '특수 바코드 (개발, 테스트, 환불)',
  pinkExceptionTab: '핑크바코드 차단 예외',
  pinkExceptionHelp: '핑크바코드 차단 예외는 이렇게 적용됩니다.',
  pinkExceptionSaveHelp:
    '바코드를 등록하면 핑크바코드 차단 예외로 저장됩니다. 등록하거나 회수할 때 장비에서 받을 목록도 자동으로 업데이트합니다.',
  pinkExceptionSyncHelp:
    '마미박스 v2.11.313 이상 장비가 켜져 있고 인터넷에 연결되어 있으면, 장비 시작 시와 매일 야간에 서버와 동기화하여 최신 목록을 적용합니다.',
  pinkExceptionOfflineHelp:
    '오프라인이거나 동기화에 실패한 장비는 마지막으로 받은 목록을 계속 사용합니다. 다음 장비 시작 또는 야간 동기화가 성공하면 변경 내용이 적용됩니다.',
  pinkExceptionRevokeHelp:
    '허용을 회수한 번호는 다음 동기화가 성공한 뒤 다시 핑크바코드 차단 대상이 됩니다.',
  pinkBaseListHelp:
    '핑크바코드로 발급된 번호에만 예외가 적용됩니다. 환불이나 사용 기간 제한 등 다른 녹화 제한은 계속 적용됩니다.',
  pinkCreatedBy: '등록자',
  pinkSave: '허용 등록',
  pinkRemove: '허용 회수',
  pinkRemoveConfirm: '이 번호의 핑크바코드 허용을 회수할까요?',
  pinkSaveComplete:
    '차단 예외를 등록하고 장비용 목록에 반영했습니다. 장비에는 다음 동기화 시 적용됩니다.',
  pinkRemoveComplete:
    '차단 예외를 회수하고 장비용 목록에 반영했습니다. 장비에는 다음 동기화 시 적용됩니다.',
  pinkSavedPublishFailed:
    '변경 내용은 저장됐지만 장비용 목록을 업데이트하지 못했습니다. 「목록 업데이트 재시도」를 눌러 주세요.',
  pinkSavedWithoutSync:
    '변경 내용을 저장했습니다. 이 환경에서는 장비 동기화가 비활성화되어 장비에는 반영되지 않습니다.',
  pinkPublishComplete: '장비용 목록을 업데이트했습니다. 장비에는 다음 동기화 시 적용됩니다.',
  pinkPublishFailed: '장비용 목록을 업데이트하지 못했습니다. 다시 시도해 주세요.',
  pinkSyncPending: '장비용 목록 업데이트가 필요합니다.',
  pinkPublishNotConfigured:
    '현재 환경에서는 장비 동기화가 비활성화되어 있습니다. 등록 또는 회수 내역은 MDA에만 저장되며 장비에는 반영되지 않습니다.',
  pinkPublished: '장비용 목록 업데이트 완료',
  pinkPublishedAt: '마지막 목록 업데이트',
  pinkRepublish: '목록 업데이트 재시도',
  pinkBarcodeRequired: '11자리 숫자 바코드를 입력해 주세요.',
  pinkReasonRequired: '승인 사유를 입력해 주세요.',
  pinkSearch: '바코드 또는 사유 검색',
  pinkLoadFailed: '핑크바코드 차단 예외 목록을 불러오지 못했습니다.',
  pinkActionFailed: '요청을 처리하지 못했습니다. 다시 시도해 주세요.',
  pinkNoPermission: '허용 예외 목록을 조회할 권한이 없습니다.',
  firstRecordingBarcodeMenu: '최초 녹화 바코드 조회',
  firstRecordingBarcodePeriod: '조회 기간',
  firstRecordingBarcodeAvailableHospitals: '선택 가능 병원',
  firstRecordingBarcodeSelectedHospitals: '선택된 병원',
  firstRecordingBarcodeHospitalUnit: '개',
  firstRecordingBarcodeSelectHospitals: '병원 선택',
  firstRecordingBarcodeSelectedHospitalCount: '선택 {{count}}개',
  firstRecordingBarcodeEmptyHospitalSelection: '선택된 병원이 없습니다.',
  firstRecordingBarcodeHospitalSearchPlaceholder: '병원명 또는 번호로 검색',
  firstRecordingBarcodeClearHospitalSelection: '전체 해제',
  firstRecordingBarcodeApplyHospitalSelection: '선택 적용',
  firstRecordingBarcodeMoreSelectedHospitals: '외 {{count}}개',
  firstRecordingBarcodeHospitalCategory: '대분류',
  firstRecordingBarcodeAllHospitals: '전체',
  firstRecordingBarcodePinkBarcodeHospitals: '핑크바코드 병원',
  firstRecordingBarcodePaidHospitals: '유료병원',
  firstRecordingBarcodeQrPaymentHospitals: 'QR 결제 병원',
  firstRecordingBarcodeSearch: '조회',
  firstRecordingBarcodeSearchBarcode: '조회 바코드',
  firstRecordingBarcodeSearchBarcodePlaceholder: '특정 바코드만 조회',
  firstRecordingBarcodeSearchComplete: '조회가 완료되었습니다. {{count}}건',
  firstRecordingBarcodeSearchResultCount: '조회 결과 {{count}}건',
  firstRecordingBarcodeFilteredResultCount: '필터 결과 {{count}}건',
  firstRecordingBarcodeUserDataRowCount: '유저 데이터 존재 {{count}}건',
  firstRecordingBarcodeFilteredUserDataRowCount: '필터 유저 데이터 존재 {{count}}건',
  firstRecordingBarcodeUserDataCsvLabel: '유저 데이터 존재',
  firstRecordingBarcodeCsvCountValue: '{{count}}건',
  firstRecordingBarcodeResultBarcodeSearchPlaceholder: '결과 내 바코드 검색',
  firstRecordingBarcodeSelectedRowCount: '선택 {{count}}건',
  firstRecordingBarcodeSendAll: '전체 문자 보내기',
  firstRecordingBarcodeSendSelected: '선택 문자 보내기',
  firstRecordingBarcodeSendOne: '문자 보내기',
  firstRecordingBarcodeMessageAction: '문자',
  firstRecordingBarcodeSendNoTarget: '발송할 조회 결과가 없습니다.',
  firstRecordingBarcodeSendNoSelected: '발송할 데이터를 선택해주세요.',
  firstRecordingBarcodeSendConfirmTitle: '문자 보내기',
  firstRecordingBarcodeSendConfirmContent: '{{count}}건에 문자를 보내시겠습니까?',
  firstRecordingBarcodeSendConfirmOk: '보내기',
  firstRecordingBarcodeSmsMessageLabel: '문자 내용',
  firstRecordingBarcodeSmsMessagePlaceholder: '발송할 문자 내용을 입력해주세요.',
  firstRecordingBarcodeSmsMessageRequired: '문자 내용을 입력해주세요.',
  firstRecordingBarcodeDefaultSmsMessage: '안녕하세요 마미톡입니다.',
  firstRecordingBarcodeSendResult:
    '문자 발송 요청 완료: 성공 {{sentCount}}건, 스킵 {{skippedCount}}건, 실패 {{failedCount}}건',
  firstRecordingBarcodeSendError: '문자 발송 요청 중 오류가 발생했습니다.',
  firstRecordingBarcodeHospitalRequired: '병원을 하나 이상 선택해주세요.',
  firstRecordingBarcodePeriodRequired: '조회 기간을 선택해주세요.',
  firstRecordingBarcodeValidationError: '입력 값을 확인해주세요.',
  firstRecordingBarcodeExportEmpty: '조회 결과가 없습니다.',
  firstRecordingBarcodeExportComplete: 'CSV 다운로드가 완료되었습니다.',
  firstRecordingBarcodeExportError: '최초 녹화 바코드 조회 중 오류가 발생했습니다.',
  downloadCsv: 'CSV 다운로드',
  streamingRestoreMenu: '스트리밍 종료 영상 복구',
  streamingRestoreExploreTitle: '복원 대상 탐색',
  streamingRestoreHistoryTitle: '복원 기록',
  streamingRestoreHistoryAll: '전체 최근 복원 기록을 보여줍니다.',
  streamingRestoreHistoryFiltered: '바코드 {{barcode}} 기준 복원 기록을 보여줍니다.',
  seq: '번호',
  barcode: '바코드',
  recordedAt: '녹화일시',
  hospitalSeq: '병원 번호',
  hospitalName: '병원명',
  userName: '등록자명',
  userPhoneNumber: '등록자 전화번호',
  fileId: '파일 ID',
  type: '유형',
  reason: '사유',
  createdBy: '등록자',
  createdAt: '생성일',
  updatedAt: '수정일',
  edit: '수정',
  delete: '삭제',
  deleteConfirm: '삭제하시겠습니까?',
  yes: '예',
  no: '아니요',
  editBarcodeDetail: '바코드 수정',
  description: '설명',
  activeFlag: '활성',
  blindRecording: '녹화 숨김',
  blindRecordingDescription: '해당 바코드로 업로드 된 녹화를 블라인드 처리합니다.',
  addSpecialBarcode: '예외 바코드 추가',
  editSpecialBarcode: '예외 바코드 수정',
  deleteSpecialBarcode: '예외 바코드 삭제',
  specialBarcodeDescription: '예외 바코드 관리',
  specialBarcodeTableDescription:
    '예외 바코드를 등록하고 관리합니다. 예외 바코드로 등록된 경우, 해당 바코드로 시작하는 녹화는 특정 조건(예: 산모 정보 없음)에서 자동으로 블라인드 처리될 수 있습니다.',
  searchBarcode: '바코드 검색',
  searchReason: '사유 검색',
  unblindRecordingsOnDelete: '연관된 영상의 블라인드 처리를 해제합니다.',
  expireClassVoucher: '클래스 바우처 만료',
  expireClassVoucherDescription: '해당 바코드로 등록된 클래스 바우처를 만료 처리합니다.',
  typeDev: '개발',
  typeTest: '테스트',
  typeRefund: '환불',
  typeFree: 'FREE',
  showFreeBarcodes: 'FREE 바코드 포함',
  bulkBarcodeInput: '바코드 목록',
  bulkBarcodeInputPlaceholder:
    '한 줄에 하나씩 붙여넣으세요. 구글 시트에서 여러 열을 복사해도 각 줄의 11자리 숫자 1개만 인식합니다.',
  barcodeInputSummary:
    '총 {{total}}줄 / 등록 가능 {{valid}}개 / 중복 {{duplicate}}개 / 확인 필요 {{invalid}}개',
  barcodeInputIssues: '확인 필요한 항목',
  barcodeInputServerFailures: '서버 등록 실패 항목',
  barcodeInputMissingBarcode: '11자리 숫자 바코드를 찾지 못했습니다.',
  barcodeInputMultipleBarcodes: '한 줄에 바코드가 2개 이상 있습니다.',
  barcodeInputDuplicate: '입력 목록에 중복된 바코드입니다.',
  noValidBarcodesToCreate: '등록 가능한 바코드가 없습니다.',
  batchAddComplete: '바코드 {{requested}}개 중 {{success}}개를 등록했습니다.',
  batchAddPartialComplete:
    '바코드 {{requested}}개 중 {{success}}개 등록했고 {{failure}}개는 다시 확인이 필요합니다.',
  freeBarcodeReadOnly: 'FREE 바코드는 자동 생성 유형이라 수정할 수 없습니다. 삭제만 가능합니다.',
  addComplete: '추가 완료',
  updateComplete: '수정 완료',
  deleteComplete: '삭제 완료',
  streamingRestoreSearchPlaceholder: '11자리 바코드를 검색하세요',
  streamingRestoreSearchHelp:
    '검색 결과는 병원별 비활성 영상 건수만 먼저 보여주고, 상세는 병원 선택 시에만 확인할 수 있습니다.',
  streamingRestoreHospital: '병원',
  streamingRestoreDisabledCount: '비활성 영상 수',
  streamingRestoreRestorableCount: '복원 가능 수',
  streamingRestoreUnrestorableCount: '복원 불가 수',
  streamingRestoreRequestedCount: '요청 건수',
  streamingRestoreRestoredCount: '복원 건수',
  streamingRestoreFailedCount: '실패 건수',
  streamingRestoreAction: '상세/복원',
  streamingRestoreOpenDetail: '상세 열기',
  streamingRestoreDrawerTitle: '{{hospitalName}} 복원 대상',
  streamingRestoreSelectedCount: '선택 {{count}}건',
  streamingRestoreStatus: '복원 가능 여부',
  streamingRestoreStatusRestorable: '복원 가능',
  streamingRestoreStatusUnrestorable: '복원 불가',
  streamingRestoreCurrentKey: '현재 s3FileKey',
  streamingRestoreExpectedKey: '복원 대상 s3FileKey',
  streamingRestoreFailureReason: '복원 불가 사유',
  streamingRestoreReasonLabel: '복원 사유',
  streamingRestoreReasonPlaceholder: '복원 사유를 입력해 주세요.',
  streamingRestoreReasonRequired: '복원 사유를 입력해 주세요.',
  streamingRestoreExecute: '복원 실행',
  streamingRestoreHistoryStatus: '처리 결과',
  streamingRestoreHistoryStatusRestored: '복원 완료',
  streamingRestoreHistoryStatusFailed: '실패',
  streamingRestoreInvalidBarcode: '정확히 11자리 숫자 바코드만 검색할 수 있습니다.',
  streamingRestoreNoSelection: '복원할 영상을 선택해 주세요.',
  streamingRestoreLoadFailed: '복원 대상 조회에 실패했습니다.',
  streamingRestoreRestoreSuccess: '복원 {{restored}}건 완료',
  streamingRestoreRestorePartial: '복원 {{restored}}건 완료, {{failed}}건 실패',
  streamingRestoreRestoreFailed: '복원 가능한 영상이 없습니다.',
  streamingRestoreEmpty: '비활성 영상이 없습니다.',
  streamingRestoreHistoryEmpty: '복원 기록이 없습니다.',
  streamingRestoreHistoryEmptyDetail: '저장된 상세 항목이 없습니다.',
};

export default barcodeTranslation;
